export const RTW_WORKERS_COMP_SERVICE_TYPE_ID = 92;
export const RTW_NON_OCC_SERVICE_TYPE_ID = 93;

export const RTW_UNION_MEMBER_OPTIONS = ['Yes', 'No', 'Unknown'] as const;

export const RTW_LIGHT_DUTY_LOCATION_OPTIONS = [
    "At the nonprofit's physical location",
    'Working from home on assigned nonprofit duties',
    "Working from the employer's worksite on assigned nonprofit duties",
] as const;

export const RTW_HOURS_PER_WEEK_FIELD_LABEL =
    'Number of Hours per Week to Schedule while in Return to Work';

export const RTW_PHYSICAL_RESTRICTIONS_MAX = 4000;
export const RTW_PRIMARY_LANGUAGE_MAX = 100;
export const RTW_HOURLY_RATE_MAX = 50;
export const RTW_TRANSITION_HOURS_MAX = 100;
export const RTW_WORK_SCHEDULE_MAX = 100;
export const RTW_ADDITIONAL_COMMENTS_MAX = 2500;

export const RTW_ALTERNATE_HOURS_CHECKBOX_LABEL =
    'Assignments are typically 32–40 hours per week. For alternate hours, check here.';

export const RTW_ALTERNATE_SCHEDULE_CHECKBOX_LABEL =
    'Assignments are typically between 7A-7P, Mon–Sat. For an alternate schedule, check here.';

const RTW_ADDITIONAL_COMMENTS_PLACEHOLDER_WC =
    "Use this place to note any of the following fields: Pre-Injury Occupation; Description of Injury; Average Weekly Wage (AWW); Average Weekly Comp Rate; Secondary Language; Special Accommodations (ie. deaf or hard of hearing, crutches, unrelated injury, etc.); Additional File Information (ie. instructions, PT schedule, appointments, transportation, etc.); Employee ID; Is this employer part of a Self-Insured Group?";

const RTW_ADDITIONAL_COMMENTS_PLACEHOLDER_NON_OCC =
    `${RTW_ADDITIONAL_COMMENTS_PLACEHOLDER_WC}; Date of Disability; Description of Disability`;

export function getRtwAdditionalCommentsPlaceholder(serviceTypeId?: number): string {
    if (serviceTypeId === RTW_NON_OCC_SERVICE_TYPE_ID) {
        return RTW_ADDITIONAL_COMMENTS_PLACEHOLDER_NON_OCC;
    }
    return RTW_ADDITIONAL_COMMENTS_PLACEHOLDER_WC;
}
